import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import styled from "styled-components";
import CustomTabs from "../CustomTabs";
import Labels from "./Labels";
import { pieChartTabs } from "../../config/Constants";

ChartJS.register(ArcElement, Tooltip, Legend);

interface Props {
  chartData: any;
  onHandleSelect: (value: number) => void;
  activeTab: number;
}

export const PieChart = ({ chartData, onHandleSelect, activeTab }: Props) => {
  const data = {
    datasets: [
      {
        data: chartData.valueArray,
        backgroundColor: chartData.colorArray,
        borderColor: chartData.colorArray,
        borderWidth: 1,
      },
    ],
  };

  const getIndexOfVenue = (venue: string, venueArray: string[]) => {
    return venueArray.indexOf(venue);
  };

  const getReservationCount = (valueArray: number[]) => {
    return valueArray.reduce(
      (partialSum: number, a: number) => partialSum + a,
      0
    );
  };

  return (
    <LayoutContainer>
      <StyledBox>
        <PieChartHeader>
          <PieChartHeaderLeft>
            <PieHeading>Outlet Reservation Count</PieHeading>
            <ReservationCount>
              {chartData?.valueArray?.length > 0 &&
                getReservationCount(chartData?.valueArray)}{" "}
              Reservations
            </ReservationCount>
          </PieChartHeaderLeft>
          <div>
            <CustomTabs
              tabs={pieChartTabs}
              activeTab={activeTab}
              // @ts-ignore
              handleTab={onHandleSelect}
            />
          </div>
        </PieChartHeader>
        {chartData?.valueArray?.length > 0 && (
          <PieChartBody>
            <PieChartContainer>
              {getReservationCount(chartData?.valueArray) === 0 ? (
                <img src={require("../../assets/images/empty_pie.png")} alt="empty-pie" />
              ) : (
                <Pie data={data} />
              )}
            </PieChartContainer>
            <LabelContainer>
              <LabelGroup>
                {chartData.venueArray
                  ?.slice(0, 4)
                  .map((venue: any, idx: number) => (
                    <Labels
                      key={idx}
                      index={idx}
                      label={venue}
                      color={
                        chartData.colorArray[
                          getIndexOfVenue(venue, chartData.venueArray)
                        ]
                      }
                      count={
                        chartData.valueArray[
                          getIndexOfVenue(venue, chartData.venueArray)
                        ]
                      }
                    />
                  ))}
              </LabelGroup>
              <LabelGroup>
                {chartData.venueArray
                  ?.slice(4, 8)
                  .map((venue: any, idx: number) => (
                    <Labels
                      key={idx}
                      index={idx}
                      label={venue}
                      color={
                        chartData.colorArray[
                          getIndexOfVenue(venue, chartData.venueArray)
                        ]
                      }
                      count={
                        chartData.valueArray[
                          getIndexOfVenue(venue, chartData.venueArray)
                        ]
                      }
                    />
                  ))}
              </LabelGroup>
              <LabelGroup>
                {chartData.venueArray
                  ?.slice(8, 12)
                  .map((venue: any, idx: number) => (
                    <Labels
                      key={idx}
                      index={idx}
                      label={venue}
                      color={
                        chartData.colorArray[
                          getIndexOfVenue(venue, chartData.venueArray)
                        ]
                      }
                      count={
                        chartData.valueArray[
                          getIndexOfVenue(venue, chartData.venueArray)
                        ]
                      }
                    />
                  ))}
              </LabelGroup>
            </LabelContainer>
          </PieChartBody>
        )}
      </StyledBox>
    </LayoutContainer>
  );
};

const LabelGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
`;
const PieChartHeaderLeft = styled.div`
  @media only screen and (max-width: 768px) {
    margin: 1rem 0;
  }
`;
const ReservationCount = styled.div`
  font-size: 1.75rem;
`;
const PieHeading = styled.div``;
const PieChartContainer = styled.div`
  width: 320px;
  height: 320px;
  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;
const PieChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.5rem;
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;
const PieChartBody = styled.div`
  display: flex;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
const LayoutContainer = styled.div`
  display: flex;
  margin-top: 2.125rem;
  flex-direction: column;
`;

const StyledBox = styled.div`
  border-radius: 8px;
  padding: 2.5rem;
  background-color: rgba(204, 204, 204, 0.3);
  @media only screen and (max-width: 768px) {
    height: auto;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    padding: 0;
  }
`;

export default PieChart;
